import React from 'react';
import { ValidatedFieldProps } from 'application/hooks/use-validated-form';
import MaskedInput from 'application/components/form-controls/masked-input';

interface Props extends ValidatedFieldProps {
  value: string;
  disabled?: boolean;
  required?: boolean;
  onChange: (value: string) => void;
}

const PracticeNumberInput = (maskedInputProps: Props) => (
  <MaskedInput mask="_______" placeholder="1234567" {...maskedInputProps} />
);

export default PracticeNumberInput;
